export const COSTRATE_LOADING = 'REDUX_SAGA_COSTRATE_LOADING';
export const GET_COSTRATE_DATA_SUCCESS = 'REDUX_SAGA_GET_COSTRATE_DATA_SUCCESS';
export const GET_COSTRATE_DATA_ERROR = 'REDUX_SAGA_GET_COSTRATE_DATA_ERROR';
export const COSTRATE_END_LOADING = 'REDUX_SAGA_COSTRATE_END_LOADING';
export const RESET_COSTRATE = 'REDUX_SAGA_RESET_COSTRATE';

export const actionGetCostRate = (dispatch, groupname, subgroup) => {
    dispatch({
        type: COSTRATE_LOADING, payload:
            { groupname: groupname, subgroup: subgroup }
    })
};

export const actionResetCostRate = (dispatch) => {
    dispatch({ type: RESET_COSTRATE })
}